import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { Toaster } from "sonner";
import { msalInstance } from "./lib/msal";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import NewRequest from "./pages/NewRequest";
import NewWFHRequest from "./pages/NewWFHRequest";
import MyRequests from "./pages/MyRequests";
import Approvals from "./pages/Approvals";
import Secretariat from "./pages/Secretariat";
import RequestDetail from "./pages/RequestDetail";
import WFHRequestDetail from "./pages/WFHRequestDetail";
import Settings from "./pages/Settings";
import Employees from "./pages/Employees";
import Administracija from "./pages/Administracija";
import Statistika from "./pages/Statistika";
import TeamCalendar from "./pages/TeamCalendar";
import Attendance from "./pages/Attendance";
import "./App.css";

const APPROVAL_ROLES = ["manager", "secretary", "dean", "prodekan"];
const SECRETARIAT_ROLES = ["secretary", "dean", "prodekan"];
const SETTINGS_ROLES = ["manager", "secretary", "dean", "prodekan", "admin"];
const ADMIN_TOOLS_ROLES = ["admin", "secretary", "dean", "prodekan"];

function Protected({ children, roles, flag }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-12 text-center serif text-xl">Učitavanje...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  const roleOk = !roles || roles.includes(user.role) || user.role === "admin";
  const flagOk = !flag || !!user[flag];
  if (!roleOk && !flagOk) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/zahtjev" element={<NewRequest />} />
              <Route path="/wfh/novi" element={<NewWFHRequest />} />
              <Route path="/zahtjevi" element={<MyRequests />} />
              <Route path="/odobrenja" element={<Protected roles={APPROVAL_ROLES} flag="can_submit_for_team"><Approvals /></Protected>} />
              <Route path="/dekanat" element={<Protected roles={SECRETARIAT_ROLES}><Secretariat /></Protected>} />
              <Route path="/postavke" element={<Protected roles={SETTINGS_ROLES}><Settings /></Protected>} />
              <Route path="/zaposlenici" element={<Employees />} />
              <Route path="/administracija" element={<Protected roles={ADMIN_TOOLS_ROLES}><Administracija /></Protected>} />
              <Route path="/statistika" element={<Protected roles={ADMIN_TOOLS_ROLES}><Statistika /></Protected>} />
              <Route path="/kalendar-tima" element={<Protected roles={APPROVAL_ROLES}><TeamCalendar /></Protected>} />
              <Route path="/prisutnost" element={<Attendance />} />
              <Route path="/zahtjev/:id" element={<RequestDetail />} />
              <Route path="/wfh/zahtjev/:id" element={<WFHRequestDetail />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
